import SearchSummary from './SearchSummary.component';
export default SearchSummary;